// extracted by mini-css-extract-plugin
export default {"tabbedTopbar":"TopbarWithCloseButton_tabbedTopbar__Za59j","closeButton":"TopbarWithCloseButton_closeButton__Eq5pJ"};